"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailsToValidate = void 0;
exports.emailsToValidate = [
    'gmai.com',
    'gamil.com',
    'gmil.com',
    'mail.com',
    'gmal.com',
    'gamail.com',
    'email.com',
    'gmeil.com',
    'hotmai.com',
    'gnail.com',
    'gemail.com',
    'hormail.com',
    'gmail.co',
    'bol.com',
    'hotmal.com',
    'homail.com',
    'hitmail.com',
    'gmsil.com',
    'hmail.com',
    'outlook.pt',
    'gmaill.com',
    'gmail.co.com',
    'hotnail.com',
    'hotmil.com',
    'gail.com',
    'gma.com',
    'hotimail.com',
    'zipmail.com.br',
    'htmail.com',
    'gmaol.com',
    'hotmail.co',
    'gmaul.com',
    'gmaim.com',
    'gmali.com',
    'aol.com',
    'gimail.com',
    'gmial.com',
    'gmail.cm',
    'gmaio.com',
    'hotamil.com',
    'outlok.com',
    'hotamail.com',
    'outook.com',
    'outllok.com',
    'gm.com',
    'gmqil.com',
    'g.com',
    'hotmail.it',
    'gml.com',
    'hotmaim.com',
    'hotmsil.com',
    'rotmail.com',
    'gmailm.com',
    'gmael.com',
    'g.mail.com',
    'hotma.com',
    'iclou.com',
    'fmail.com',
    'hotmaul.com',
    'gemeil.com',
    'iclod.com',
    'outloo.com',
    'hot.com',
    'gmaeil.com',
    'e-mail.com',
    'hotail.com',
    'ail.com',
    'hotmaol.com',
    'jotmail.com',
    'oultook.com',
    'outllook.com',
    'hotmaill.com',
    'gotmail.com',
    'teste.com',
    'ibest.com.br',
    'hotmeil.com',
    'teste.com.br',
    'hotmaio.com',
    'hotmail.fr',
    'gemil.com',
    'gmaik.com',
    'gmeio.com',
    'gmx.com',
    'outloook.com',
    'hortmail.com',
    'yhaoo.com.br',
    'htomail.com',
    'gmaiil.com',
    'otlook.com',
    'gamil.com.br',
    'g.comail.com',
    'yahoo.br',
    'jmail.com',
    'gmail.om',
    'gmaail.com',
    'gmel.com',
    'yahool.com',
    'vmail.com',
    'alterado.com',
    'hotmail.cm',
    'outlool.com',
    'gmeil.com.br',
    'gmaip.com',
    'glmail.com',
    'gamil.com.com',
    'gma8l.com',
    'hotmail.co.com',
    'autlook.com',
    'hotmail.es',
    'yhaoo.com',
    'yandex.com',
    'gmai.com.com',
    'hotmqil.com',
    'iclud.com',
    'hotemail.com',
    'com.br',
    'gmailcom.br',
    'gmail.br',
    'live.fr',
    'hot.mail.com',
    'gmaii.com',
    'outkook.com',
    'oitlook.com',
    'oulook.com',
    'outloock.com',
    'hotmail.co.uk',
    'gameil.com',
    'gamail.com.br',
    'uol.com',
    'hotmaip.com',
    'yaho.com.br',
    'yahoo.fr',
    'hotmial.com',
    'hptmail.com',
    'gmil.com.br',
    'icloid.com',
    'gmmail.com',
    'ivloud.com',
    'zoho.com',
    'hoail.com',
    'yohoo.com',
    'yaoo.com',
    'yhoo.com.br',
    'hotimal.com',
    'terra.com',
    'gemel.com',
    'hotmel.com',
    'gmal.com.br',
    'gamai.com',
    'hotlook.com',
    'hotmailm.com',
    'icluod.com',
    'mai.com',
    'gmailmail.com',
    'gemail.com.br',
    'gmais.com',
    'hitmail.com.br',
    'outllok.com.br',
    'icoud.com',
    'oultlook.com',
    'yopmail.com',
    'mail.ru',
    'gmai.com.br',
    'hotmaiil.com',
    'hotmai.com.br',
    'uahoo.com.br',
    'e.mail.com',
    'cloud.com',
    'qq.com',
    'uotlook.com',
    'gmailil.com',
    'hotmali.com',
    'hotmaail.com',
    'hootmail.com',
    'yahoo.es',
    'yaoo.com.br',
    'outoook.com',
    'outook.com.br',
    'hotmmail.com',
    'gimal.com',
    'outlook.co',
    'homtail.com',
    'oltlook.com',
    'gmaiel.com',
    'gmail.c.com',
    'gmaile.com',
    'gemal.com',
    'gmails.com',
    'gmaiol.com',
    'gmaiu.com',
    'gami.com',
    'gmamil.com',
    'gamel.com',
    'gmei.com',
    'gama.com',
    'gmi.com',
    'gailm.com',
    'gmill.com',
    'g.ail.com',
    'gnail.com.com',
    'email.com.br',
    'hormai.com',
    'hot.comail.com',
    'hotimil.com',
    'cmail.com',
    'hotm.com',
    'htmai.com',
    'botmail.com',
    'ichoud.com',
    'bo.com.br',
    'iclooud.com',
    'incloud.com',
    'amrap.com.br',
    'mail.com.br',
    'mal.com',
    'man.com',
    'tahoo.com.br',
    'tpa.com.br',
    'utlook.com',
    'vol.com.br',
    'yaho.com',
    'yahoo.cm',
    'yahoo.co.br',
    'yahoocom.br',
    'yahooo.com.br',
    'yhoo.com',
    'gimeil.com',
    'gmaial.com',
];
//# sourceMappingURL=emailsToValidate.js.map